export default __webpack_public_path__ + "static/media/NIAS0400.34I-29075_-16910_0.13795f70.jpg";